import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getDeliveryRequest } from "../../../utilities";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Delivery-request statuses mirror the My Requests page: 0 pending,
// 1 accepted, 2 rejected.
const MyExteriorRequestsWidget = () => {
  const user = useSelector(selectUser);
  const [requests, setRequests] = useState(null);

  useEffect(() => {
    if (!user?.email) return;
    getDeliveryRequest(user.email, (data) =>
      setRequests(Array.isArray(data) ? data : [])
    );
  }, [user?.email]);

  const count = (status) =>
    requests.filter((r) => r.requestStatus === status).length;

  return (
    <WidgetFrame title="My Exterior Requests" to="/windowdoor/requests">
      {requests ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={count(0)} label="Pending" />
          <WidgetStat value={count(1)} label="Accepted" />
          <WidgetStat value={count(2)} label="Rejected" />
        </div>
      ) : (
        <WidgetEmpty>Loading your requests…</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default MyExteriorRequestsWidget;
